import React, { useState } from "react"
import { nanoid } from "nanoid"

import click from "../assets/click.svg"
import speak from "../assets/speak.svg"
import search from "../assets/search.svg"
import check from "../assets/check.svg"
import back from "../assets/back.svg"
import home from "../assets/home.svg"
import { useGuide } from "../contexts/GuideContext"
import { useUser } from "../contexts/UserContext"
import { Swiper, SwiperSlide } from "swiper/react"
import SwiperCore, { Pagination } from "swiper"
import "swiper/swiper-bundle.min.css"
import Service from "../services/Service"

SwiperCore.use([ Pagination ])

function Guide() {
    const guide = useGuide()
    const user = useUser()
    const { setShowGuide, notSupport } = guide
    const [ isNever, setIsNever ] = useState( false )
    let browser
    const never = document.querySelector( ".never" )

    if ( navigator.userAgent.includes("Firefox") ) {
        browser = "Firefox"
    } else if ( navigator.userAgent.includes("Safari") ) {
        browser = "Safari"
    } else if ( navigator.userAgent.includes("Opera") ) {
        browser = "Opera"
    } else if ( navigator.userAgent.includes("Internet Explorer") ) {
        browser = "Internet Explorer"
    } else {
        browser = "Browser"
    }

    // localStorage.removeItem( "isNever" )

    const handleChange = () => setIsNever( !isNever )

    const handleClick = (e) => {
        console.log( "guide", user?.uid )
        if ( never?.firstChild.checked === false ) {
            setIsNever( true )
            Service.storeData( "isNever", { uid: user?.uid, isNever: true } )
        } else {
            setIsNever( false )
            Service.storeData( "isNever", { uid: user?.uid, isNever: false } )
        }
        if ( isNever === false ) {
            setIsNever( true )
            e.target.previousSibling.checked = true
            Service.storeData( "isNever", { uid: user?.uid, isNever: true } )
        } else {
            setIsNever( false )
            e.target.previousSibling.checked = false
            Service.storeData( "isNever", { uid: user?.uid, isNever: false } )
        }
    }

    const handleShowGuide = () => setShowGuide( false )

    const info = [
        {
            title: "Step 1",
            message: "Please read the following slides to get to know how to use Voice Search feature",
        },
        {
            title: "Step 2",
            message: "Speak to the browser using the following commands",
            image: speak
        },
        {
            title: "Search Commands",
            command: [
                "\"Search (for) <recipe>\"",
                "\"Find <recipe>\""
            ],
            image: search
        },
        {
            title: "Check Recipe Command",
            command: [
                "\"Check (recipe) one/two/three...\"",
            ],
            image: check
        },
        {
            title: "Go Back Command",
            command: [
                "\"Go back\"",
            ],
            image: back
        },
        {
            title: "Go Home Command",
            command: [
                "\"Go home\"",
            ],
            image: home
        },
        {
            title: "Finally!",
            message: "Click the \"Got it!\" button to get to the home page and start roaming around!",
            image: click
        },
    ]

    return (
        <div id="guideContainer">
            <section className="guide">
                {
                    notSupport
                        ?   <>
                            <h2>Sorry, Voice Recognition is not supported on {browser}. It now works the best on Chrome!</h2>
                            <section className="never">
                                <input 
                                    type="checkbox" 
                                    name="never" 
                                    aria-label="never"
                                    value={isNever}
                                    onChange={handleChange} />
                                <label htmlFor="never" onClick={handleClick}>Never show this again</label>
                            </section>
                            <button onClick={handleShowGuide}>Got It!</button>
                        </>
                        :   <>
                            <h2>Voice Recognition is ready!</h2>

                            <Swiper
                                pagination={{ clickable: true }}
                                spaceBetween={20}
                                slidesPerView={1}
                                loop="true"
                            >
                                {
                                    info.map( item => {
                                        return  <SwiperSlide key={nanoid()} className="onboardingSlide" >    
                                            <div>
                                                <h3>{item.title}</h3>
                                                <p>{item.message}</p>
                                                { item?.command?.map( text => <p key={nanoid()}><code>{text}</code></p>) }
                                                <img className="illustration" src={item?.image} alt="" />
                                            </div>
                                        </SwiperSlide>
                                    })
                                }
                            </Swiper>

                            <section className="never">
                                <input 
                                    type="checkbox" 
                                    name="never" 
                                    aria-label="never"
                                    value={isNever}
                                    onChange={handleChange} />
                                <label htmlFor="never" onClick={handleClick}>Never show this again</label>
                            </section>

                            <button onClick={handleShowGuide}>Got It!</button>
                        </>
                }
            </section>
        </div>
    )
}

export default Guide
